import React from "react";
import { Accordion, Card } from "react-bootstrap";
import "./styles.scss";

export default ({ title, items = [] }) => (
  <>
    <h1 className="text-dark py-5">{title}</h1>
    <Accordion>
      {items.map((i, index) => (
        <Card>
          <Card.Header>
            <Accordion.Toggle
              variant="link"
              className="btn d-flex justify-content-between w-100"
              eventKey={index}
            >
              <p className="font-weight-bold mb-0">{i.title}</p>
              <span>{">"}</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey={index}>
            <Card.Body className="ml-4">{i.body}</Card.Body>
          </Accordion.Collapse>
        </Card>
      ))}
    </Accordion>
  </>
);
